import React, { Component } from 'react';
import './HistorialPrevAsis.css';

import { getmtosprev, clearErrors, deleteMtoPreventivo, postMto } from '../../../redux/actions/dataactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaArrowLeft, FaCheck, FaCheckCircle, FaExclamationTriangle, FaFilePdf } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { postAprobarMtoPerfil } from '../../../redux/actions/dataasistencialactions';



//getmtosprev
export class HistorialPrevAsis extends Component {

  constructor(){
    super();
    this.state={
      errors:{},
      aprobado:{},
      open:false,
      opendelete:false,
      mtoid:'',
      clienteid:'',
      equipoid:'',
    };
    
};

       componentDidMount(){
        this.props.getmtosprev(this.props.equipoId);
       }

       static getDerivedStateFromProps(props, state) {
        const newState = {};
    
        if (props.UI.errors) {
            newState.errors = props.UI.errors;
        }
    
        if (props.UI.aprobado) {
           newState.aprobado = props.UI.aprobado;
        }
    
        return Object.keys(newState).length > 0 ? newState : null;
    }


       handleOpen=(rawdatamtoid)=>{

        this.setState({open:true,mtoid:rawdatamtoid,errors:{},aprobado:{}});
    
        };

        handleClose=()=>{
          // this.props.clearErrors();
          if(this.state.aprobado.mensaje||this.state.errors.error){
            this.props.getmtosprev(this.props.equipoId);
            this.setState({open:false,errors:{},aprobado:{}});
          }

         this.setState({open:false,errors:{},aprobado:{}});
           };
       

            // hay que hacer otro aprobar mto 
      handleSubmit=()=>{


        this.props.postAprobarMtoPerfil(this.state.mtoid)
      }
    
      
    render() {

         const {mtospreventivos,loadingmto,equipo}= this.props.data; 
         const { UI:{loading}}=this.props;
         const {errors}=this.state;
     
        const sortedMtospreventivos = !loadingmto
          ? [...mtospreventivos].sort(
              (a, b) => new Date(b.fecha) - new Date(a.fecha)
            )
          : [];

        const columns = [
          {
            field: 'acciones',
            headerName: 'Acciones',
            width: 150,
            sortable: false,
            filterable: false,
            renderCell: params => {
              const pdfLink = `/dashboard/perfilcliente/equipo/hojadevidapdf/reportepdfmto/${equipo.credentials.idprestador}/${this.props.equipoId}/${params.row.mtoid}/1`;
              return (
                <Box>
                  <Link to={pdfLink} style={{ color: '#03178C' }}>
                    <Tooltip title="Ver Reporte PDF">
                      <IconButton size="small">
                        <FaFilePdf />
                      </IconButton>
                    </Tooltip>
                  </Link>
                  <Tooltip title="Aprobar Mantenimiento">
                <span>
                  <IconButton
                    size="small"
                    onClick={() => this.handleOpen(params.row.mtoid)}
                    disabled={params.row.aprobado === true || params.row.estado === "Sin realizar"}
                  >
                    <CheckCircleIcon
                      sx={{
                        color:
                          params.row.estado === "Sin realizar"
                            ? 'gray'
                            : params.row.aprobado
                            ? 'green'
                            : 'red'
                      }}
                      fontSize="inherit"
                    />
                  </IconButton>
                </span>
              </Tooltip>
                </Box>
              );
            }
          },
          { field: 'fecha', headerName: 'Fecha', width: 120 },
          { field: 'horainicio', headerName: 'Hora Inicio', width: 120 },
          { field: 'horafinal', headerName: 'Hora Final', width: 120 },
          {
            field: 'aprobado',
            headerName: 'Aprobado',
            width: 120,
            renderCell: params => (params.row.aprobado ? 'Sí' : 'No')
          },
          
        ];

        let mapeomtospreventivos = !loadingmto ? (
          <Box
            sx={{
              height: 500,
              width: '100%',
              mt: 2,
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: 'primary.main',
                color: 'white'
              }
            }}
          >
            <DataGrid
              rows={sortedMtospreventivos}
              columns={columns}
              getRowId={row => row.mtoid}
              components={{
                Toolbar: () => (
                  <Box p={1}>
                    <GridToolbarQuickFilter placeholder="Buscar..." />
                  </Box>
                )
              }}
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 500
            }}
          >
            <CircularProgress size={50} color="primary" />
          </Box>
        );
            
        return (
              <div className="listamtoprog-container">
              
              <div className="listamtoprog-table">
                <Typography sx={{ fontSize: '16px', color: '#03178c', fontWeight: 600, textAlign: 'center', mb: 1 }}>
                                Mantenimientos Preventivos Realizados
                              </Typography>
              {mapeomtospreventivos}
              </div>
              <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                fullWidth
                maxWidth="sm"
              >
                {this.state.aprobado.mensaje ? (
                  <>
                    <DialogTitle>
                      <Typography
                        sx={{
                          fontSize: '20px',
                          fontWeight: 600,
                          color: '#0468BF',
                          textAlign: 'center'
                        }}
                      >
                        Reporte Aprobado Exitosamente
                      </Typography>
                    </DialogTitle>
                    <DialogContent>
                      <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item>
                          <FaCheck color="#20b90c" size={40} />
                          <Typography
                        sx={{
                          fontSize: '20px',
                          fontWeight: 400,
                          color: '#20b90c',
                          textAlign: 'center'
                        }}
                      >
                        Reporte Aprobado Exitosamente
                      </Typography>
                        </Grid>
                      </Grid>
                    </DialogContent>
                    <DialogActions>
                      <Tooltip title="Cerrar">
                        <IconButton onClick={this.handleClose}>
                          <FaArrowLeft color="#D3D7DC" />
                        </IconButton>
                      </Tooltip>
                      {loading ? (
                        <CircularProgress size={30} color="primary" />
                      ) : (
                        <Tooltip title="Continuar">
                          <IconButton onClick={this.handleClose}>
                            <FaCheckCircle color="#20b90c" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </DialogActions>
                  </>
                ) : errors.error ? (
                  <>
                    <DialogTitle>
                      <Typography
                        sx={{
                          fontSize: '20px',
                          fontWeight: 600,
                          color: '#0468BF',
                          textAlign: 'center'
                        }}
                      >
                        {errors.error}
                      </Typography>
                    </DialogTitle>
                    <DialogContent>
                      <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item>
                          <FaExclamationTriangle color="#ffd631" size={40} />
                          <Typography
                        sx={{
                          fontSize: '20px',
                          fontWeight: 400,
                          color: '#ffd631',
                          textAlign: 'center'
                        }}
                      >
                        {errors.error}
                      </Typography>
                        </Grid>
                      </Grid>
                    </DialogContent>
                    <DialogActions>
                      <Tooltip title="Cerrar">
                        <IconButton onClick={this.handleClose}>
                          <FaArrowLeft color="#D3D7DC" />
                        </IconButton>
                      </Tooltip>
                      {loading ? (
                        <CircularProgress size={30} color="primary" />
                      ) : (
                        <Link
                          to={`/dashboard/inventarioequiposasistencial/hojadevidaequipo/${this.props.equipoId}`}
                          style={{ color: '#ffd631' }}
                        >
                          <Tooltip title="Continuar">
                            <IconButton>
                              <FaCheckCircle color="#ffd631" />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      )}
                    </DialogActions>
                  </>
                ) : (
                  <>
                    <DialogTitle>
                      <Typography
                        sx={{
                          fontSize: '20px',
                          fontWeight: 600,
                          color: '#0468BF',
                          textAlign: 'center'
                        }}
                      >
                        ¿Estás seguro de Aprobar este Mantenimiento?
                      </Typography>
                    </DialogTitle>
                    <DialogContent>
                      <Grid container spacing={2} />
                    </DialogContent>
                    <DialogActions>
                      <Tooltip title="Cerrar">
                        <IconButton onClick={this.handleClose}>
                          <FaArrowLeft color="#D3D7DC" />
                        </IconButton>
                      </Tooltip>
                      {loading ? (
                        <CircularProgress size={30} color="primary" />
                      ) : (
                        <Tooltip title="Aprobar Mantenimiento">
                          <IconButton onClick={this.handleSubmit}>
                            <FaCheckCircle color="#03178C" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </DialogActions>
                  </>
                )}
              </Dialog>
     



            

             

  
            </div>
        )
    }
}


HistorialPrevAsis.propTypes = {
    
      getmtosprev: PropTypes.func.isRequired,
      data:PropTypes.object.isRequired,
      clearErrors:PropTypes.func.isRequired,
      UI:PropTypes.object.isRequired,
      deleteMtoPreventivo:PropTypes.func.isRequired,
      postAprobarMtoPerfil:PropTypes.func.isRequired 
    };
  
  const mapActionsToProps={getmtosprev,clearErrors,deleteMtoPreventivo,postMto,postAprobarMtoPerfil };
  
  const mapStateToProps = (state)=>({
      data:state.data,
      UI:state.UI
  })
  
  
  
  export default connect(mapStateToProps,mapActionsToProps)(HistorialPrevAsis);
  
